import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ProjectsService } from '../projects/projects.service';

@Component({
  host: {
    'test-id': 'exchange-wrapper',
    class: 'page-content',
  },
  selector: 'exchange-wrapper',
  template: `
    <header class="content-header">
      <h4 class="vision-h4">{{ 'exchange.' + pageTitleKey + '.title' | translate }}</h4>
    </header>
    <fw-exchange-root class="content-body fill-white"></fw-exchange-root>
  `,
})
export class ExchangeWrapperComponent implements OnDestroy, OnInit {
  pageTitleKey: string

  constructor(
    private projectsService: ProjectsService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.loadExchangeScript();
    const urlSegments = this.activatedRoute.snapshot.url;
    this.pageTitleKey = urlSegments.some(segment => segment.path === 'admin') ? 'admin' : 'data';
  }

  ngOnDestroy(): void {
    // pick up any new imported projects
    this.projectsService.getProjects({ refresh: true });
  }

  loadExchangeScript(): void {
    const scriptId = 'flywheel-exchange';
    const scriptSource = '/exchange/main.js';
    if (document.querySelector(`script#${scriptId}`)) {
      return;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = scriptSource;
    script.type = 'module';
    document.body.appendChild(script);
  }
}
